import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_AUDIENCE_ESTIMATE_BY_ID = gql`
  query GetByID($request: TwitterAudienceEstimateRequest!) {
    GetAudienceEstimate(request: $request) {
      data
    }
  }
`;
